import STATISTICS_GET from '../../graphql/statistics/get.graphql'

import {processQuery, genericMutations} from '../utils'

export default {
    namespaced: true,
    state: {
        detail: null,
    },

    mutations: {
        ...genericMutations('detail'),
    },

    actions: {
        async get({commit}, data) {
            return await processQuery(this, STATISTICS_GET, 'statistics.get', data, 'statistics/setDetail')
        },
        async loadZones({commit}, data) {
            return await processQuery(this, STATISTICS_GET, 'statistics.get', data, 'statistics/setDetail')
        }
    }
}